import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'
const API_PATH = 'api/v2/admins/tl_payment_methods/rates'

const PaymentMethodRatesApiV2 = {

  /**
   * Get list of ::TlPaymentMethod::Rate
   * Invoke `GET api/v2/admins/tl_payment_methods/rate`
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params   = QueryParamsUtil.format(tableState, additionalFilters)
    const path     = API_PATH
    const response = axios.get(path, { params })
    return response
  },

  create: async (values) => {
    const path     = API_PATH
    const response = axios.post(path, values)
    return response
  },

  update: (request) => {
    const path     = `${API_PATH}/update`
    const response = axios.patch(path, request)
    return response
  }
}

export default PaymentMethodRatesApiV2